import { useForm } from 'antd/lib/form/Form';
import { useTranslation } from 'react-i18next';

import {
  Button,
  ButtonsWrapper,
  Form,
  Loader,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';

import { useRouteQuery } from 'src/common/helpers';
import { useCreateWorkingCondition } from 'src/hooks/working-conditions/create-working-condition.hook';
import { WorkingConditions } from 'src/components/employee/working-conditions';
import { useGetEmployeeQuestionnaireByMemberId } from 'src/hooks/employee-questionnaire/get-employee-questionnaire-by-memberId.hook';

import { HeaderContainer } from './working-conditions-create.styles';
import {
  EmployeeNoticePeriodTypesEnum,
  EmployeeProbationTypesEnum,
} from '@thinknet-gmbh/platform-common';

type InitialCreateData = {
  companyId: string;
  companyLocationId: string;
  companyBusinessAddressId: string;
  companyDepartmentId: string;
  jobId: string;
  jobSupervisorId: string;
};

const WorkingConditionsCreate = ({
  initialValues,
  onCancel,
}: {
  initialValues?: InitialCreateData;
  onCancel: () => void;
}) => {
  const { t } = useTranslation(['common', 'employee']);

  const [form] = useForm();

  const query = useRouteQuery();
  const _id: string = query.get('id') || '';

  const { employeeQuestionnaire, loading } = useGetEmployeeQuestionnaireByMemberId(_id);

  const { jobCompanyId, jobLocation = {} } = employeeQuestionnaire;

  const createWorkingCondition = useCreateWorkingCondition({ onSuccess: onCancel });

  const onFinish = (values: any) => {

    createWorkingCondition({
      variables: {
        payload: {
          ...values,
          memberId: _id,
        },
      },
    });
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <br />
      <HeaderContainer>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('employee:labels.createWorkingConditions')}
        </Typography>
      </HeaderContainer>
      <Form
        layout="vertical"
        onFinish={onFinish}
        form={form}
        initialValues={{
          ...{
            probationType: EmployeeProbationTypesEnum.DAYS,
            noticePeriodType: EmployeeNoticePeriodTypesEnum.MONTHS,
            ...initialValues,
          },
          companyId: jobCompanyId,
          ...jobLocation,
          active: true,
        }}
      >
        <WorkingConditions form={form} />
        <ButtonsWrapper>
          <Button type="primary" htmlType="submit">
            {t('common:buttons.save')}
          </Button>
          <Button onClick={onCancel}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </div>
  );
};

export default WorkingConditionsCreate;
